<template>
    <div>
        <div class="doc-cabecalho">
            <h1 class="doc-titulo">
                {{ titulo }}
                <small v-if="selo" class="doc-selo">{{ selo }}</small>
            </h1>

            <label class="doc-versao-rotulo" for="doc-versao">Versão</label>
            <b-form-select
                id="doc-versao"
                v-model="versao"
                :options="versoes"
                size="sm"
                class="doc-versao"
            />
        </div>

        <div id="swagger-ui" class="mb-5" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            versao: 'v1',
            versoes: [
                { text: 'v1', value: 'v1' },
                { text: 'v2', value: 'v2' }
            ],
            titulo: 'Documentação da API',
            selo: ''
        };
    },
    watch: {
        versao() {
            this.renderizar();
        }
    },
    mounted() {
        const cssHref = 'https://unpkg.com/swagger-ui-dist@5/swagger-ui.css';
        const jsSrc = 'https://unpkg.com/swagger-ui-dist@5/swagger-ui-bundle.js';

        const ensureCss = () => {
            if (document.querySelector(`link[href="${cssHref}"]`)) return;
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssHref;
            document.head.appendChild(link);
        };

        const loadScript = () => new Promise((resolve, reject) => {
            if (window.SwaggerUIBundle) { resolve(); return; }
            const script = document.createElement('script');
            script.src = jsSrc;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = reject;
            document.body.appendChild(script);
        });

        ensureCss();
        loadScript().then(() => this.renderizar());
    },
    methods: {
        // O seletor de versao e proprio, e nao o do Swagger UI: aquele vive no topbar,
        // que so existe no swagger-ui-standalone-preset. Aqui carregamos apenas o
        // swagger-ui-bundle, entao passar "urls" seria aceito pela configuracao e
        // ficaria sem interface para trocar — a v2 seria inalcancavel.
        renderizar() {
            const SwaggerUI = window.SwaggerUIBundle;

            if (!SwaggerUI) return;

            const vm = this;

            SwaggerUI({
                url: this.getUrl(),
                dom_id: '#swagger-ui',
                supportedSubmitMethods: [],
                defaultModelsExpandDepth: -1,
                tryItOutEnabled: true,
                requestInterceptor(request) {
                    let token = sessionStorage.getItem('token');
                    if (token) {
                        request.headers['Authorization'] = token;
                    }
                    return request;
                },
                responseInterceptor(response) {
                    if (response.status === 401) {
                        window.location = process.env.VUE_APP_URL;
                    }
                    return response;
                },
                onComplete() {
                    vm.adotarTituloDaSpec();

                    const link = document.querySelector('#swagger-ui .information-container .main .link');
                    if (link) link.remove();
                    const scheme = document.querySelector('#swagger-ui .scheme-container');
                    if (scheme) scheme.remove();
                }
            });
        },

        // O titulo sai do bloco que o Swagger monta e passa a ser renderizado aqui, para
        // ficar na mesma linha do seletor de versao. Copiar o texto em vez de fixa-lo
        // mantem o titulo vindo da spec: trocar "info.title" no YAML continua refletindo
        // na tela. O bloco original e escondido por CSS, nao removido — o texto precisa
        // continuar no DOM para ser lido, e a descricao logo abaixo dele permanece.
        adotarTituloDaSpec() {
            const titulo = document.querySelector(
                '#swagger-ui .information-container .info hgroup.main h1.title'
            );

            if (!titulo) return;

            const selo = titulo.querySelector('span');

            this.selo = selo ? selo.textContent.trim().replace(/\s+/g, ' ') : '';
            this.titulo = Array.from(titulo.childNodes)
                .filter(no => no.nodeType === Node.TEXT_NODE)
                .map(no => no.textContent)
                .join('')
                .trim();
        },

        getUrl() {
            const action = this.versao === 'v2' ? '/documentacao/v2' : '/documentacao';

            // VUE_APP_API_URL ja termina em /rotas/api.php.
            return `${process.env.VUE_APP_API_URL}?action=${action}`;
        }
    }
}
</script>

<style>
/* 35px = a coluna de conteudo do Swagger: 20px do .wrapper + 15px do .col-12. */
.doc-cabecalho {
    padding: 0 35px;
    margin-bottom: 0.75rem;
}

.doc-titulo {
    margin: 0 0 0.6rem;
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1.2;
}

.doc-versao-rotulo {
    display: block;
    margin: 0 0 0.2rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #6c757d;
}

.doc-versao {
    width: auto;
    min-width: 6rem;
}

.doc-selo {
    font-size: 0.75rem;
    font-weight: 400;
    color: #6c757d;
    vertical-align: middle;
    margin-left: 0.35rem;
}

/*
 * O titulo do Swagger e escondido, nao removido: adotarTituloDaSpec() le o texto
 * daqui, e a descricao logo abaixo continua visivel. Sem !important porque o
 * seletor ja e mais especifico que o do swagger-ui.css.
 */
#swagger-ui .information-container .info hgroup.main {
    display: none;
}

#swagger-ui .information-container {
    padding-top: 0;
}

#swagger-ui .information-container .info {
    margin-top: 0;
}
</style>
